import { Chain, TokenQuery } from 'graphql/data/Token'
import { useFetchedCurrentTokenDatas } from 'graphql/thegraph/tokens/currenTokenData'

/**
 * Fetch token information
 */
export function useTokenInformation(
  tokenAddress: string | undefined,
  isNative: boolean,
  chain: Chain
): {
  loading: boolean
  error: boolean
  data: TokenQuery | undefined
} {

  if(!tokenAddress) {
    return {
      loading: false,
      error: true,
      data: undefined
    }
  }

  const {data: currentTokenDataMap, loading: fetchLoading, error: errorLoading } = useFetchedCurrentTokenDatas([tokenAddress?.toLowerCase()])

  if(!currentTokenDataMap || fetchLoading || errorLoading) {
    return {
      loading: false,
      error: true,
      data: undefined
    }
  }

  const tokenInformation = currentTokenDataMap[tokenAddress?.toLowerCase()]

  const data: any = {
    "token": {
        "name": tokenInformation.name || undefined,
        "chain": chain,
        "address": isNative ? null : tokenInformation ? tokenInformation.address : "",
        "symbol": isNative ? "XDC" : tokenInformation ? tokenInformation.symbol : "",
        "decimals": Number(tokenInformation.decimals),
        "standard": isNative ? "NATIVE" : "ERC20",
        "market": {
            "totalValueLocked": {
                "value": Number(tokenInformation.tvlUSD) || 0,
                "currency": "USD"
            },
            "price": {
                "value": Number(tokenInformation.priceUSD) || undefined,
                "currency": "USD"
            },
            "volume24H": {
                "value": Number(tokenInformation.volumeUSD) || 0,
                "currency": "USD"
            },
            "priceHigh52W": {
                "value": Number(tokenInformation.hight52week) || 0
            },
            "priceLow52W": {
                "value": Number(tokenInformation.low52week) || 0
            }
        },
        "project": {
            "description": "No description",
            "homepageUrl": "",
            "twitterName": "",
            "logoUrl": "",
            "tokens": [
            ]
        }
    }
}

  return {
    loading: false,
    error: false,
    data,
  }
}